module.exports = __webpack_public_path__ + "fonts/ralewayblack.222dfc6.woff2";